(function () {
  'use strict';
  if (window.__qiGiftOptionsLoaded) return;
  window.__qiGiftOptionsLoaded = true;
  const isoToday = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  function createCalendar(input, root) {
    const locale = document.documentElement.lang || 'en-GB';
    const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const parse = value => { const [y, m, d] = value.split('-').map(Number); return new Date(y, m - 1, d, 12); };
    const picker = document.createElement('div');
    picker.className = 'qi-date-picker';
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.id = input.id;
    trigger.className = 'qi-date-trigger';
    input.id += '-value';
    input.hidden = true;
    const label = document.createElement('span');
    trigger.appendChild(label);
    trigger.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M3 10h18M8 3v4m8-4v4"/></svg>');
    const calendar = document.createElement('div');
    calendar.className = 'qi-calendar';
    calendar.id = `${trigger.id}-calendar`;
    calendar.hidden = true;
    calendar.setAttribute('role', 'group');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', calendar.id);
    const header = document.createElement('div');
    header.className = 'qi-calendar-header';
    const prev = document.createElement('button');
    const next = document.createElement('button');
    [prev, next].forEach(button => { button.type = 'button'; button.className = 'qi-calendar-nav'; });
    prev.textContent = '‹'; next.textContent = '›';
    prev.setAttribute('aria-label', root.dataset.calendarPrevious);
    next.setAttribute('aria-label', root.dataset.calendarNext);
    const title = document.createElement('span');
    title.className = 'qi-calendar-title';
    title.id = `${calendar.id}-title`;
    title.setAttribute('aria-live', 'polite');
    calendar.setAttribute('aria-labelledby', title.id);
    header.append(prev, title, next);
    const weekdays = document.createElement('div');
    weekdays.className = 'qi-calendar-weekdays';
    weekdays.setAttribute('aria-hidden', 'true');
    for (let index = 0; index < 7; index++) {
      const day = document.createElement('span');
      day.textContent = new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(new Date(2024, 0, 1 + index));
      weekdays.appendChild(day);
    }
    const grid = document.createElement('div');
    grid.className = 'qi-calendar-grid';
    const error = document.createElement('span');
    error.className = 'qi-date-error'; error.id = `${trigger.id}-error`; error.hidden = true;
    error.setAttribute('aria-live', 'polite');
    trigger.setAttribute('aria-describedby', error.id);
    calendar.append(header, weekdays, grid);
    picker.append(trigger, calendar, error);
    input.insertAdjacentElement('afterend', picker);
    let active = parse(input.value || isoToday());
    let month = new Date(active.getFullYear(), active.getMonth(), 1, 12);
    const close = () => { calendar.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
    const clearError = () => { error.hidden = true; error.textContent = ''; trigger.removeAttribute('aria-invalid'); };
    function render(focusDay = false) {
      title.textContent = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(month);
      const today = parse(isoToday());
      prev.disabled = month.getFullYear() === today.getFullYear() && month.getMonth() === today.getMonth();
      grid.replaceChildren();
      const offset = (month.getDay() + 6) % 7;
      for (let i = 0; i < offset; i++) grid.appendChild(document.createElement('span'));
      const days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
      for (let day = 1; day <= days; day++) {
        const date = new Date(month.getFullYear(), month.getMonth(), day, 12);
        const value = iso(date);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'qi-calendar-day';
        button.textContent = String(day); button.dataset.date = value;
        button.disabled = value < isoToday();
        button.tabIndex = value === iso(active) ? 0 : -1;
        button.setAttribute('aria-label', new Intl.DateTimeFormat(locale, { dateStyle: 'full' }).format(date));
        button.setAttribute('aria-pressed', String(input.value === value));
        if (value === isoToday()) button.setAttribute('aria-current', 'date');
        button.addEventListener('click', () => {
          input.value = value; input.setCustomValidity(''); clearError();
          input.dispatchEvent(new Event('change', { bubbles: true }));
          close(); trigger.focus();
        });
        button.addEventListener('focus', () => { active = date; });
        grid.appendChild(button);
      }
      if (focusDay) grid.querySelector(`[data-date="${iso(active)}"]`)?.focus();
    }
    function sync() {
      trigger.disabled = input.disabled;
      label.textContent = input.value ? new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(parse(input.value)) : root.dataset.calendarChoose;
      if (input.disabled) { close(); clearError(); }
    }
    function show() {
      input.min = isoToday();
      active = parse(input.value && input.value >= isoToday() ? input.value : isoToday());
      month = new Date(active.getFullYear(), active.getMonth(), 1, 12);
      calendar.hidden = false; trigger.setAttribute('aria-expanded', 'true'); render(true);
    }
    trigger.addEventListener('click', () => calendar.hidden ? show() : close());
    function shiftMonth(amount) {
      const target = new Date(month.getFullYear(), month.getMonth() + amount, 1, 12);
      const today = parse(isoToday());
      if (target.getFullYear() < today.getFullYear() || (target.getFullYear() === today.getFullYear() && target.getMonth() < today.getMonth())) return;
      month = target;
      active = new Date(month.getFullYear(), month.getMonth(), Math.min(active.getDate(), new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate()), 12);
      if (iso(active) < isoToday()) active = today;
      render();
    }
    prev.addEventListener('click', () => shiftMonth(-1));
    next.addEventListener('click', () => shiftMonth(1));
    picker.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !calendar.hidden) { event.preventDefault(); event.stopPropagation(); close(); trigger.focus(); return; }
      if (!event.target.matches('.qi-calendar-day')) return;
      const delta = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
      if (delta !== undefined || event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const date = new Date(active);
        date.setDate(date.getDate() + (delta ?? (event.key === 'Home' ? -(date.getDay() + 6) % 7 : 6 - (date.getDay() + 6) % 7)));
        if (iso(date) < isoToday()) return;
        active = date; month = new Date(active.getFullYear(), active.getMonth(), 1, 12); render(true);
      } else if (event.key === 'PageUp' || event.key === 'PageDown') {
        event.preventDefault(); shiftMonth(event.key === 'PageUp' ? -1 : 1); grid.querySelector(`[data-date="${iso(active)}"]`)?.focus();
      }
    });
    picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) close(); });
    const outside = event => { if (!picker.contains(event.target)) close(); };
    document.addEventListener('click', outside);
    input.addEventListener('invalid', event => {
      event.preventDefault(); error.textContent = root.dataset.dateMessage; error.hidden = false;
      trigger.setAttribute('aria-invalid', 'true'); trigger.focus();
    });
    input.addEventListener('change', () => { clearError(); sync(); });
    sync();
    return { sync, destroy: () => document.removeEventListener('click', outside) };
  }
  const jsonRequest = async (path, payload) => {
    const response = await fetch(rootUrl() + path, {
      method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status) throw new Error(result.description || result.message || 'Unable to update your basket.');
    return result;
  };
  function init(root) {
    if (root.dataset.qiInitialised) return;
    const form = root.closest('form');
    if (!form) return;
    root.dataset.qiInitialised = 'true';
    form.setAttribute('data-qi-voucher-form', '');
    const host = root.closest('product-form');
    const section = root.closest('.shopify-section') || document;
    const info = root.closest('[id^="ProductInfo-"]');
    const native = root.dataset.nativeRecipient === 'true';
    const physical = root.dataset.mode === 'physical';
    const originalButton = form.querySelector('[name="add"]');
    const button = root.querySelector('[data-qi-physical-submit]');
    const panel = root.querySelector('[data-qi-recipient-panel]');
    const mode = root.querySelector('[data-qi-send-mode]');
    const sendDate = root.querySelector('[data-qi-send-date]');
    const dateProperty = root.querySelector('[data-qi-send-date-property]');
    const openToggle = root.querySelector('[data-open-date-toggle]');
    const openDate = root.querySelector('[data-qi-open-date]');
    const calendars = Array.from(root.querySelectorAll('input[type="date"]'), input => createCalendar(input, root));
    const messageToggle = root.querySelector('[data-qi-message-toggle]');
    const messagePanel = root.querySelector('[data-qi-message-panel]');
    const recipientMessage = messagePanel?.querySelector('textarea');
    function syncMessage() {
      if (recipientMessage) recipientMessage.disabled = panel.hidden || messagePanel.hidden;
    }
    messageToggle?.addEventListener('click', () => {
      messagePanel.hidden = !messagePanel.hidden;
      messageToggle.textContent = messagePanel.hidden ? messageToggle.dataset.addLabel : messageToggle.dataset.removeLabel;
      messageToggle.setAttribute('aria-expanded', String(!messagePanel.hidden));
      if (messagePanel.hidden) recipientMessage.value = '';
      syncMessage();
      if (!messagePanel.hidden) recipientMessage.focus();
    });
    let busy = false;
    let variantUnsubscribe;
    function blocked() {
      return info?.dataset.qiEnded === 'true' || info?.dataset.qiChristmasEnded === 'true' ||
        form.querySelector('[name="id"]')?.disabled || !form.querySelector('[name="id"]')?.value ||
        originalButton?.disabled || originalButton?.getAttribute('aria-disabled') === 'true';
    }
    function setError(message) {
      const wrapper = host?.querySelector('.product-form__error-message-wrapper');
      const text = wrapper?.querySelector('.product-form__error-message');
      if (text) { text.textContent = message; wrapper.hidden = !message; }
    }
    function syncDate() {
      if (!panel) return;
      const direct = root.querySelector('[data-qi-gift-for]:checked')?.value === 'someone';
      const scheduled = direct && mode.value === 'scheduled';
      root.querySelector('[data-qi-send-date-wrapper]').hidden = !scheduled;
      sendDate.disabled = !scheduled;
      sendDate.required = scheduled;
      sendDate.min = isoToday();
      dateProperty.disabled = !scheduled;
      const parts = sendDate.value.split('-');
      dateProperty.value = scheduled && parts.length === 3 ? (native ? sendDate.value : `${parts[2]}/${parts[1]}/${parts[0]}`) : '';
      const offset = root.querySelector('[data-qi-native-offset]');
      if (offset) offset.value = String(new Date().getTimezoneOffset());
      calendars.forEach(calendar => calendar.sync());
    }
    function syncRecipient() {
      if (!panel) return;
      const direct = root.querySelector('[data-qi-gift-for]:checked')?.value === 'someone';
      panel.hidden = !direct;
      panel.querySelectorAll('[data-qi-recipient-input]').forEach(field => { field.disabled = !direct; field.setCustomValidity?.(''); });
      panel.querySelector('input[type="email"]').required = direct;
      mode.disabled = !direct;
      syncMessage();
      syncDate();
    }
    function syncPhysical(currentVariant) {
      if (!physical) return;
      button.disabled = busy || window.__qiGiftCartUpdating || blocked() || root.dataset.physicalReady !== 'true';
      const summary = root.querySelector('[data-qi-gift-total]');
      const data = info?.querySelector('script[id^="qi-product-json-"]') || section.querySelector(`#qi-product-json-${root.dataset.sectionId}`);
      let variant = currentVariant;
      try { variant ||= JSON.parse(data?.textContent || '{}').variants?.find(v => String(v.id) === form.querySelector('[name="id"]')?.value); } catch (_) {}
      if (summary && variant) summary.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format((variant.price + Number(root.dataset.addonPrice)) / 100);
    }
    root.querySelectorAll('[data-qi-gift-for]').forEach(input => input.addEventListener('change', syncRecipient));
    mode?.addEventListener('change', () => { sendDate.setCustomValidity(''); syncDate(); });
    sendDate?.addEventListener('change', () => { sendDate.setCustomValidity(''); syncDate(); });
    openToggle?.addEventListener('change', () => {
      root.querySelector('[data-open-date-wrapper]').hidden = !openToggle.checked;
      openDate.disabled = !openToggle.checked;
      openDate.required = openToggle.checked;
      openDate.min = isoToday();
      openDate.setCustomValidity('');
      if (!openToggle.checked) openDate.value = '';
      calendars.forEach(calendar => calendar.sync());
    });
    const message = root.querySelector('[data-qi-property="Gift message"]');
    message?.addEventListener('input', () => { root.querySelector('[data-message-count]').textContent = String(message.value.length); });
    root.querySelectorAll('input, textarea').forEach(field => field.addEventListener('input', () => field.setCustomValidity('')));
    function validFields(fields) {
      for (const field of fields) {
        if (field.disabled) continue;
        if (field.required && !field.value.trim()) field.setCustomValidity(root.dataset.requiredMessage);
        if (field.type === 'date' && field.required && (!field.value || field.value < isoToday())) field.setCustomValidity(root.dataset.dateMessage);
        if (!field.reportValidity()) { field.focus(); return false; }
      }
      return true;
    }
    async function addPhysical() {
      if (busy || window.__qiGiftCartUpdating || window.__qiCartCheckoutChecking || blocked() || root.dataset.physicalReady !== 'true') return;
      if (!validFields(root.querySelectorAll('[data-physical-required], [data-qi-open-date]'))) return;
      setError('');
      busy = true;
      window.__qiGiftCartUpdating = true;
      button.disabled = true;
      button.classList.add('loading');
      button.querySelector('.loading__spinner')?.classList.remove('hidden');
      const uid = window.crypto?.randomUUID?.() || `qi-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      let verified = false;
      let writeConfirmed = false;
      try {
        const data = new FormData(form);
        const quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
        const variantId = Number(data.get('id'));
        const addonId = Number(root.dataset.addonVariantId);
        const props = {};
        for (const [key, value] of data) {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (match && typeof value === 'string') props[match[1]] = value;
        }
        ['Recipient email', 'Recipient name', 'Message', 'Send on', 'Send as gift', '__shopify_send_gift_card_to_recipient', '__shopify_offset'].forEach(key => delete props[key]);
        Object.assign(props, { 'Delivery format': 'Premium Physical Gift Card', '_Qi Gift UID': uid, '_Qi Gift view': 'physical-gift-cards' });
        root.querySelectorAll('[data-qi-property]').forEach(field => {
          if (!field.disabled && field.value.trim()) props[field.dataset.qiProperty] = field.value.trim();
        });
        const payload = { items: [
          { id: variantId, quantity, properties: props, ...(data.get('selling_plan') ? { selling_plan: data.get('selling_plan') } : {}) },
          { id: addonId, quantity, properties: { '_Qi Gift UID': uid, '_Linked voucher': root.dataset.productTitle, '_Voucher variant ID': String(variantId) } }
        ] };
        try { await jsonRequest('cart/add.js', payload); writeConfirmed = true; }
        catch (error) {
          try {
            const state = await jsonRequest('cart.js');
            const updates = Object.fromEntries(state.items.filter(item => item.properties?.['_Qi Gift UID'] === uid).map(item => [item.key, 0]));
            if (Object.keys(updates).length) {
              const cleaned = await jsonRequest('cart/update.js', { updates });
              if (cleaned.items?.some(item => item.properties?.['_Qi Gift UID'] === uid)) throw new Error(root.dataset.addError);
            }
          } catch (_) { error.qiUncertain = true; }
          throw error;
        }
        const state = await jsonRequest('cart.js');
        const pair = state.items.filter(item => item.properties?.['_Qi Gift UID'] === uid);
        if (pair.length !== 2 || pair.some(item => item.quantity !== quantity) || !window.QiGiftCartRules?.inspect(state).valid) {
          const updates = Object.fromEntries(pair.map(item => [item.key, 0]));
          if (pair.length) await jsonRequest('cart/update.js', { updates });
          writeConfirmed = false;
          throw new Error(root.dataset.addError);
        }
        verified = true;
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents) {
          const sections = await jsonRequest(`?sections=cart-drawer,cart-icon-bubble&_qi=${Date.now()}`);
          if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error(root.dataset.refreshMessage);
          const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          if (!parsed.querySelector('#CartDrawer')) throw new Error(root.dataset.refreshMessage);
          const quickAddModal = root.closest('quick-add-modal');
          const cartTrigger = quickAddModal?.openedBy || button;
          quickAddModal?.hide(true);
          drawer.classList.remove('is-empty');
          drawer.setActiveElement?.(cartTrigger);
          drawer.renderContents({ sections });
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else window.location.assign(window.routes?.cart_url || rootUrl() + 'cart');
      } catch (error) {
        setError(verified ? root.dataset.refreshMessage : error.message || root.dataset.addError);
        if (verified || writeConfirmed || error.qiUncertain) window.location.assign(window.routes?.cart_url || rootUrl() + 'cart');
      } finally {
        busy = false;
        window.__qiGiftCartUpdating = false;
        button.classList.remove('loading');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
        syncPhysical();
      }
    }
    button?.addEventListener('click', addPhysical);
    form.addEventListener('submit', event => {
      if (physical) {
        event.preventDefault(); event.stopImmediatePropagation(); addPhysical(); return;
      }
      syncDate();
      if (window.__qiCartCheckoutChecking || blocked() || !validFields(panel.querySelectorAll('input:not([type="hidden"]), textarea'))) {
        event.preventDefault(); event.stopImmediatePropagation(); return;
      }
      if (host) host.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }, true);
    if (physical && originalButton) {
      const observer = new MutationObserver(() => syncPhysical());
      observer.observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      root.qiCleanup = () => { observer.disconnect(); variantUnsubscribe?.(); calendars.forEach(calendar => calendar.destroy()); };
    }
    form.querySelector('[name="id"]')?.addEventListener('change', () => syncPhysical());
    if (physical && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data?.sectionId) === (root.closest('product-info')?.dataset.originalSection || root.dataset.sectionId)) syncPhysical(event.data.variant);
      });
    }
    if (!root.qiCleanup) root.qiCleanup = () => calendars.forEach(calendar => calendar.destroy());
    syncRecipient(); syncPhysical();
  }
  function initAll(scope) {
    if (scope.matches?.('[data-qi-gift-options]')) init(scope);
    scope.querySelectorAll('[data-qi-gift-options]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  new MutationObserver(records => {
    for (const record of records) {
      record.addedNodes.forEach(node => { if (node.nodeType === 1) initAll(node); });
      record.removedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const roots = node.matches('[data-qi-gift-options]') ? [node] : node.querySelectorAll('[data-qi-gift-options]');
        roots.forEach(root => { if (!root.isConnected) root.qiCleanup?.(); });
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
